<div class="body">
    <br />
    <br />
    <div class="row">
        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Entidad de pensión </label> </div>

        <div class="col-lg-5">
            <td>
                  <mat-form-field appearance="outline" class="mat-input">
                    <mat-select name="entidadPension" #entidadPension="ngModel" [disabled]="afiliado.deshabilitado" required
                        [(ngModel)]="afiliado.entidadPension">
                        <mat-option *ngFor="let estado of this.afiliado.entidadesPensiones" [value]="estado.id">
                            {{estado.descripcion}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>

        </div>

    </div>
    <br />
    <div class="row">
        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Tipo de pensión </label> </div>

        <div class="col-lg-5">
            <mat-form-field appearance="outline" class="mat-input">
                <mat-select name="tipoPension" #tipoPension="ngModel" [disabled]="afiliado.deshabilitado" required
                    [(ngModel)]="afiliado.tipoPension">
                    <mat-option *ngFor="let estado of this.afiliado.tiposPensiones" [value]="estado.id">
                        {{estado.descripcion}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>

    </div>
    <br />
    <div class="row">
        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Monto de pensión </label> </div>

        <div class="col-lg-5">
            <input id="montoPension" name="montoPension" class="form-control" [(ngModel)]="afiliado.montoPension" required
            [disabled]="afiliado.deshabilitado"  [maxlength]="8" (input)="soloNumeros($event)" type="text" required>
        </div>
    </div>
    <br />
    <div class="row">
        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Modalidad de pensión </label> </div>

        <div class="col-lg-5">
            <mat-form-field appearance="outline" class="mat-input">
                <mat-select name="modalidadPension" #modalidadPension="ngModel" [disabled]="afiliado.deshabilitado" required
                    [(ngModel)]="afiliado.modalidadPension">
                    <mat-option class="custom-option" [title]="estado.descripcion" *ngFor="let estado of this.afiliado.modalidadesPensiones" [value]="estado.id">
                        {{estado.descripcion}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>

    </div>
    <div class="col-lg-3"> </div>
    <div class="col-lg-3"> </div>

</div>

<!--/form-->